import React, { useState, useEffect } from 'react'
import Publicaciones from './Publicacionesphp'
import Mesas from './Mesasphp'
import HorariosCursos from './HorariosCursos'
import Normativasphp from './Normaticasphp'

const Panel = () => {
    const [token, setToken] = useState(null)
    const [loading, setLoading] = useState(true)
    const [seccion, setSeccion] = useState('') 
    
useEffect(() => {
  const verificarSesion = async () => {
    try {
      const res = await fetch('https://www.cpem41.edu.ar/backend.php/session_check.php', {
        credentials: 'include'
      });

      // Si el backend tiró HTML o error, evitamos crashear el .json()
      const contentType = res.headers.get('content-type') || '';
      let data = null;

      if (contentType.includes('application/json')) {
        data = await res.json();
      } else {
        const text = await res.text();
        console.warn('Respuesta no-JSON de session_check:', text);
        data = null;
      }

      if (data && data.logged_in === true) {
        setToken(true);
      } else {
        console.warn('No logged_in o check inválido:', data);
        window.location.replace('/'); // evita volver al panel con “atrás”
      }
    } catch (error) {
      console.error('Error verificando sesión:', error);
      window.location.replace('/');
    } finally {
      setLoading(false);
    }
  };

  verificarSesion();
}, []);



    const cargarSeccionPublicaciones = () => {
        setSeccion('publicaciones')
    }

    const cargarSeccionMesas = () => {
        setSeccion('mesas')
    }

    const cargarSeccionNormativas = () => {
        setSeccion('normativas')
    }

    const cerrarSesion = async () => {
    try {
        await fetch('https://www.cpem41.edu.ar/backend.php/session_cerrar.php', {
        method: 'POST',
        credentials: 'include' // 👈 importante para enviar la cookie de sesión
        })

        // Limpiar datos del frontend
        localStorage.removeItem('user')

        // Redirigir al inicio
        window.location.href = '/'
    } catch (error) {
        console.error('Error cerrando sesión:', error)
    }
    }


    if (loading) {
        return <div>Cargando...</div>
    }

    return (
        <div className="seccion_menu">
            <div className="seccion">
                <h1>Panel Administrador</h1>
                <div className="btn" onClick={cargarSeccionPublicaciones}>
                    Publicaciones
                </div>
                <div className="btn" onClick={cargarSeccionMesas}>
                    Mesas
                </div>
                <div className="btn" onClick={cargarSeccionNormativas}>
                    Circulares Internas
                </div>
                <div className="btn" onClick={cerrarSesion}>
                    Cerrar Sesión
                </div>
            </div>

            {/* Renderizamos las secciones basadas en el estado 'seccion' */}
            {seccion === 'publicaciones' && <Publicaciones />}
            {seccion === 'mesas' && <Mesas />}
            {seccion === 'normativas' && <Normativasphp />}
        </div>
    )
}

export default Panel
